import { ApiEndpoints } from '@contracts';
import { AUTH_ENDPOINT } from './api-endpoints/auth-endpoint';
import { BILLING_ENDPOINTS } from './api-endpoints/billing-endpoint';
import { EXPLORE_ENDPOINTS } from './api-endpoints/explore-endpoint';
import { GROUP_BASELINE_ENDPOINTS } from './api-endpoints/group-baseline-endpoint';
import { METER_ENDPOINTS } from './api-endpoints/meter-endpoint';
import { REPORT_ENDPOINT } from './api-endpoints/report-endpoint';
import { TENANTS_ENDPOINTS } from './api-endpoints/tenants-endpoint';
import { USER_ENDPOINTS } from './api-endpoints/user-endpoint';
import { TAGS_ENDPOINTS } from './api-endpoints/tags-endpoint';
import { DASHBOARD_ENDPOINTS } from './api-endpoints/dashboard-endpoint';

export const DEFAULT_API_ENDPOINTS: ApiEndpoints = {
  auth: AUTH_ENDPOINT,
  report: REPORT_ENDPOINT,
  user: USER_ENDPOINTS,
  meter: METER_ENDPOINTS,
  tenants: TENANTS_ENDPOINTS,
  explore: EXPLORE_ENDPOINTS,
  group_baseline: GROUP_BASELINE_ENDPOINTS,
  billing: BILLING_ENDPOINTS,
  tags: TAGS_ENDPOINTS,
  dashboard: DASHBOARD_ENDPOINTS,
};
